import { useCallback } from 'react';

import { useMutation } from 'src/graphql';
import { UPDATE_DATASHEET_QUESTION_RESULT_COMMENT } from 'src/graphql/job/mutation';

export default () => {
  const [updateDatasheetQuestionResultComment, { loading }] = useMutation(UPDATE_DATASHEET_QUESTION_RESULT_COMMENT);

  const updateCommentCallback = useCallback(async (props) => {
    return updateDatasheetQuestionResultComment({
      variables: props,
    });
  },
  [],
  );

  return {
    updateCommentCallback,
    loading
  }
};
